<app-media-explorer-v2
  [dialogRef]="dialogRef"
  [readOnlyFields]="dialogData.readOnlyFields"
  [model]="dialogData.model"
  [type]="dialogData.type"
  [shownFiles]="dialogData.shownFiles"
  [files]="dialogData.files"
  [availableExtensions]="dialogData.availableExtensions"
  [hasDeleteRight]="true"
  [hasWriteRight]="true"
  style="display: block; height: 100%;">
</app-media-explorer-v2>
